import apiClient from "@/services/apiClient";

export async function sendContactMessage({ name, email, subject, message }) {
  const { data } = await apiClient.post("/public/contact", { name, email, subject, message });
  return data;
}
